<template>
    <section class="platform">
        <section class="platform-radio" @click="changePlatformRadio($event)">
            <span :class="{'active' : platformRadio === 0}" data-type="0">全部</span>
            <span :class="{'active' : platformRadio === 1}" data-type="1">美团</span>
            <span :class="{'active' : platformRadio === 2}" data-type="2">点评</span>
        </section>
        <section class="date" v-if="option.dateRadio">
            <section class="date-radio" @click="changeDateRadio($event)">
                <span :class="{'active' : dateRadio === 0}" data-type="0">昨天</span>
                <span :class="{'active' : dateRadio === 1}" data-type="1">最近7天</span>
                <span :class="{'active' : dateRadio === 2}" data-type="2">最近30天</span>
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .platform {
        right: 0;
        height: 52px;
        background-color: #FFF;
        margin-bottom: 20px;
        padding: 10px 0;
        overflow: hidden;
        z-index: 2;
        position: fixed;
        top: 87px;
        left:161px;
        > .platform-radio {
            height: 100%;
            display: inline-flex;
            > span {
                height: 100%;
                line-height: 32px;
                cursor: pointer;
                margin-left: 30px;
                &.active {
                    border-bottom: 3px solid #2ca4f7;
                }
            }
        }
        > .date {
            float: right;
            height: 100%;
            margin-right: 20px;
            > .date-radio {
                border: 1px solid #c6cacf;
                height: 100%;
                width: 270px;
                display: inline-flex;
                > span {
                    width: 90px;
                    height: 100%;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    &:nth-of-type(n+2) {
                        border-left: 1px solid #c6cacf;
                    }
                    &.active {
                        color: #FFF;
                        background-color: #2ca4f7;
                    }
                }
            }
        }
    }
</style>

<script>
    import MomentFormat from '../../filters/moment-format'

    export default {
        data () {
            return {
                platformRadio: 0, // 平台
                dateRadio: 0,  // 昨天、7天、30天
                dateRange: {
                    startDate: MomentFormat.getYestoday(),
                    endDate: MomentFormat.getYestoday()
                }
            }
        },
        props: ['option'],
        methods: {
            // 切换昨天、7天、30天
            changeDateRadio (e) {
                const ev = e.target;
                if (ev.tagName === 'SPAN') {
                    const type = parseInt(ev.dataset.type);
                    if (this.dateRadio === type) {
                        return;
                    }
                    this.dateRadio = type;
                    switch (this.dateRadio) {
                        case 0:
                            this.dateRange.startDate = MomentFormat.getYestoday();
                            this.dateRange.endDate = MomentFormat.getYestoday();
                            break;
                        case 1:
                            this.dateRange.startDate = MomentFormat.getSevenDate();
                            this.dateRange.endDate = MomentFormat.getYestoday();
                            break;
                        case 2:
                            this.dateRange.startDate = MomentFormat.getThirtyDate();
                            this.dateRange.endDate = MomentFormat.getYestoday();
                            break;
                    }
                    this.updateData();
                }
            },

            // 切换平台
            changePlatformRadio (e) {
                const ev = e.target;
                if (ev.tagName === 'SPAN') {
                    const type = parseInt(ev.dataset.type);
                    if (this.platformRadio === type) {
                        return;
                    }
                    this.platformRadio = type;
                    this.updateData();
                }
            },

            // 更新数据
            updateData () {
                this.$emit('updateData', { salePlatform: this.platformRadio, dateRange: this.dateRange, dateRadio: this.dateRadio
                });
            }
        }
    }
</script>






// WEBPACK FOOTER //
// PlatForm.vue?25827cf7